import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

export default class CommentBottomActions extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      actionCallback: PropTypes.function,
      icon: PropTypes.string,
      iconSize: PropTypes.number,
      key: PropTypes.string,
      label: PropTypes.string,
      status: PropTypes.string
    }),
    item: PropTypes.object,
    disabled: PropTypes.boolean
  };

  static defaultProps = {
    disabled: false
  };

  state = {
    isLoading: false
  };

  get isLoading() {
    return this.state.isLoading;
  }

  get isDisabled() {
    const { disabled } = this.props;

    return disabled || this.isLoading;
  }

  toggleLoading = () => this.setState({ isLoading: !this.isLoading });

  executeAction = async (action, item, status) => {
    if (action && !this.isDisabled) {
      this.toggleLoading();

      await action(item, status);

      this.toggleLoading();
    }
  };

  render() {
    const { actions, item } = this.props;
    const mainClass = 'comment-list__actions-buttons';
    const componentClass = classNames(mainClass, {
      [`${mainClass}--disabled`]: this.isDisabled
    });

    return (
      <div className={componentClass}>
        {(actions || []).map(({ key, actionCallback, status, icon, label }) => (
          <div
            key={key}
            data-test="comment-action"
            className={`${mainClass}__function`}
            onClick={this.executeAction.bind(
              this,
              actionCallback,
              item,
              status
            )}
          >
            <div className={`${mainClass}__function__icon`}>
              <FontAwesomeIcon icon={icon} />
            </div>
            <div className={`${mainClass}__function__label`}>
              <I18n label={label} />
            </div>
          </div>
        ))}
      </div>
    );
  }
}
